module.exports = __webpack_public_path__ + "img/uk-gc-3.68b5a7a1.png";